import { useState, useEffect, useCallback } from "react"

import { typeTextContent } from "@tfg/types/endpoints/traceability"

import { i18n, Locale } from "~/i18n"

export type GetTranslationCallback = (textContent: typeTextContent) => string

export const getTranslation = (
  textContent: typeTextContent,
  langauge?: Locale
) => {
  const currentLang = langauge ?? i18n.language

  if (!textContent) return ""

  const translations = textContent.TextTranslation.find(
    (t) => t.translatedLanguage === currentLang.toUpperCase()
  )

  return translations?.translation ?? textContent.originalText
}

export const useCurrentLanguage = (): Locale => {
  const [currentLang, setCurrentLang] = useState<Locale>(
    i18n.language as Locale
  )

  useEffect(() => {
    const handleLanguageChange = () => setCurrentLang(i18n.language as Locale)
    i18n.on("languageChanged", handleLanguageChange)
    return () => i18n.off("languageChanged", handleLanguageChange)
  }, [])

  return currentLang
}

export const useGetTranslation = (textContent: typeTextContent) => {
  const currentLang = useCurrentLanguage()

  return getTranslation(textContent, currentLang)
}

export const useGetTranslationCallback = (): GetTranslationCallback => {
  const currentLang = useCurrentLanguage()

  return useCallback(
    (textContent: typeTextContent) => getTranslation(textContent, currentLang),
    [currentLang]
  )
}
